import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';
import { setAnalyticsUserId, trackPageView } from '../lib/analytics';

/** Sends SPA page views and syncs GA4 user_id for portal customers/vendors. */
export function AnalyticsTracker() {
  const location = useLocation();
  const user = useAuthStore((s) => s.user);

  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location.pathname, location.search]);

  useEffect(() => {
    if (user && user.role === 'customer') {
      setAnalyticsUserId(user.id);
    } else {
      setAnalyticsUserId(null);
    }
  }, [user]);

  return null;
}
